module.exports = __webpack_public_path__ + "static/media/EventDrivenArch.25943944.png";